<template>
	
	<div :style="{width: qrwidth+'px',height: qrheight+'px'}" ref="qrCodeUrl"></div>
	</div>
</template>

<script>
	import QRCode from 'qrcodejs2'
	export default {
		props:['txtstr','qrwidth','qrheight'],
		created() {
			
		},
		mounted() {
			this.creatQrCode();
		},
		methods:{
			creatQrCode() {
				var qrcode = new QRCode(this.$refs.qrCodeUrl, {
					text: this.txtstr, // 需要转换为二维码的内容
					width: this.qrwidth,
					height: this.qrheight,
					colorDark: '#000000',
					colorLight: '#ffffff',
					correctLevel: QRCode.CorrectLevel.H
				})
			},
		}
	}
</script>

<style>
</style>
